import React, {useState, useEffect} from 'react';
import * as yup from 'yup';
import {useFormik} from 'formik';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { regex } from '@capsovision/capso_utils';
import CountdownButton from "../UI/CountdownButton";

export default function CodeLoginForm ({method, handleGetCode, handleCodeSubmit}) {

	const [curStep, setStep] = useState(0);
	const [receiver, setReceiver] = useState('');

	const [accountList, setAccountList] = useState([]);

	const [counter, setCounter] = useState(30);

	useEffect(() => {
		const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
		return () => clearInterval(timer);
	}, [counter]);

	const handleBack = () => {
		setStep(0);
		setAccountList([]);
		formik.resetForm();
	}

	const receiverForm = useFormik({
		initialValues: {
			phone: '',
			email: '',
			method: method
		},
		validationSchema: yup.object({
			email: yup
				.string()
				.matches(regex.email, 'Please check the format of your email'),
			phone: yup
				.string()
				.matches(regex.usphone, 'Invalid phone number format, must be 10 digits number like 1002003000')
		}),
		onSubmit: async () => {
			await handleGetCode({
				method,
				receiver
			});
			setStep(1)
		},
	});

	useEffect(() => {
		setReceiver(method === 'text' ? receiverForm.values.phone : receiverForm.values.email);
	}, [receiverForm.values]);

	const formik = useFormik({
		initialValues: {
			code: '',
			accountId: '',
		},
		validationSchema: yup.object({
			code: yup
				.string()
				.required()
				.length(6, 'Verification code has 6 digits')
		}),
		onSubmit: async (values) => {
			const returnedList = await handleCodeSubmit({
				method,
				receiver,
				...values
			})
			if (returnedList && returnedList.length > 0) {
				setAccountList(returnedList);
			}
		}
	});

	return (
		<React.Fragment>
			<Box component="form" onSubmit={receiverForm.handleSubmit} sx={{ mt: 1, display: curStep === 0 ? null : "none"  }}>
				{
					method === 'text' ?
						(
							<TextField
								margin="normal"
								required
								fullWidth
								id="phone"
								label="Phone"
								name="phone"
								autoComplete="phone"
								autoFocus
								value={receiverForm.values.phone}
								onChange={receiverForm.handleChange}
								error={receiverForm.touched.phone && Boolean(receiverForm.errors.phone)}
								helperText={receiverForm.touched.phone && receiverForm.errors.phone}
							/>
						) :
						(
							<TextField
								margin="normal"
								required
								fullWidth
								id="email"
								label="Email"
								name="email"
								autoComplete="email"
								autoFocus
								value={receiverForm.values.email}
								onChange={receiverForm.handleChange}
								error={receiverForm.touched.email && Boolean(receiverForm.errors.email)}
								helperText={receiverForm.touched.email && receiverForm.errors.email}
							/>
						)
				}
				<Button
					color="primary"
					type="submit"
					fullWidth
					variant="contained"
					sx={{ mt: 3, mb: 2 }}
				>
					Get Code
				</Button>
			</Box>
			<Box component="form" onSubmit={formik.handleSubmit} sx={{ mt: 1, display: curStep === 1 ? null : "none"  }}>
				<Typography variant="subtitle2" gutterBottom component="div">
					We will send a temporary verification code to {receiver} if it is registered. Please type in the code you received below.
				</Typography>
				<TextField
					margin="normal"
					required
					fullWidth
					id="code"
					label="Code"
					name="code"
					autoFocus
					value={formik.values.code}
					onChange={formik.handleChange}
					error={formik.touched.code && Boolean(formik.errors.code)}
					helperText={formik.touched.code && formik.errors.code}
					InputProps={{
						endAdornment:
							<InputAdornment position="end">
								<CountdownButton
									color="secondary"
									variant="outlined"
									text={'Resend'}
									initCounter={30}
									interval={60}
									handler={() => handleGetCode({
										method,
										receiver
									})}
									helperText={"Didn't receive the code? Resend"}
								/>
							</InputAdornment>
					}}
				/>
				{
					accountList.length ? (
						<FormControl required fullWidth>
							<InputLabel id="account-select-label">Hospital</InputLabel>
							<Select
								labelId="account-select-label"
								key="accountId"
								label="Hospital *"
								value={formik.values.accountId}
								onChange={(e) => {
									formik.setFieldValue('accountId', e.target.value)
								}}
							>
								{ accountList.map(acc => (<MenuItem key={acc.accountId} value={acc.accountId}>{acc.orgName}</MenuItem>)) }
							</Select>
						</FormControl>

					) : null
				}
				<Button
					type="submit"
					fullWidth
					color="primary"
					variant="contained"
					sx={{ mt: 3, mb: 2 }}
				>
					Submit
				</Button>
				<Button
					fullWidth
					variant="contained"
					color="warning"
					sx={{ mb: 2 }}
					onClick={handleBack}
				>
					Back
				</Button>
			</Box>
		</React.Fragment>
	)
}